export const LEAVE_FORM_CALL_ATTEMPTS = `
  query leaveFormCallAttempts($tenant_id: Int!, $filter: FilterLeaveFormCallAttemptInput) {
    leaveFormCallAttempts(tenant_id: $tenant_id, filter: $filter) {
      __typename
      ... on LeaveFormCallAttempt {
        id
        leave_form_id
        attempt_number
        status
        call_date
        comment
        its
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
